module.exports = __webpack_public_path__ + "assets/img/bank.1450d07b.png";